/**
 * Simple pub/sub for theme events (Shopify skeleton compatibility).
 */
window.publish = window.publish || function () {};
window.subscribe = window.subscribe || function () { return function () {}; };
